/**
 * @class Module
 *
 * Represents license module
 */
export default class Module {
    /**
     * @param code {String} module string identifier
     * @param data {Array|Object} module data specifier
     */
    constructor(code, data = null) {
        this._code = code;
        this._data = data;

        if (this._code === null) {
            throw new Error("Invalid Module values");
        }
    }

    get code() {
        return this._code;
    }

    set code(value) {
        this._code = value;
    }

    get data() {
        return this._data;
    }

    set data(value) {
        this._data = value;
    }

    /**
     * @return {String}
     */
    toString() {
        return "Module (" + this._code + ")";
    }
}
